// Imports
import { faAt } from '@fortawesome/pro-solid-svg-icons';
import { StepNumbers } from '../../app';
import Input from '../../../shareables/foundation/front-end/components/forms/fields/input';


// Define the accepted props
interface Props {
	stepNumber: StepNumbers;
	emailGetter: React.MutableRefObject<(() => string) | undefined>;
	storybookEmail?: string;
}


// Function component
const SignUp: React.FC<Props> = ({ stepNumber, emailGetter, storybookEmail }) => (
	<Input
		name='email'
		type={stepNumber === 0 ? 'email' : 'hidden'}
		label='Email address'
		icon={faAt}
		autoFocus={stepNumber === 0}
		bindGetter={(getter) => (emailGetter.current = getter)}
		initialValue={storybookEmail}
		maxLength={75}
		required
	/>
);

export default SignUp;
